// CreateAdmin.tsx
import React, { useState, useRef, useEffect } from "react";

import {
  Modal,
  TextInput,
  PasswordInput,
  Text,
  Button,
  Group,
  Select,
  NumberInput,
} from "@mantine/core";
import { DateTimePicker, DateInput } from "@mantine/dates";
import { Dropzone } from "@mantine/dropzone";
import { IconPhoto } from "@tabler/icons-react";
import "@mantine/dates/styles.css";
import moment from "moment";
import classes from "./WebOrderView.module.css";

interface WebOrderProps {
  isVisible: boolean;
  onClose: () => void;
  onUpdateStatus: (data: any) => void;
  orderData: any;
}

const WebOrderUpdateModal: React.FC<WebOrderProps> = ({
  isVisible,
  onClose,
  onUpdateStatus,
  orderData,
}) => {
  const [orderDetails, setOrderDetails] = useState<any>(orderData);

  useEffect(() => {
    setOrderDetails(orderData);
    // console.log(orderData)
  }, [orderData]);

  const handleUpdateStatus = () => {
    // Check if any field is empty
    // console.log(newVoucher);

    if (
      !orderDetails?.statusId 
    ) {
      // Display a warning message (you can use a library or create a custom modal for this)
      alert("Please fill in all of the required details");
      return;
    }

    if (
        orderDetails?.statusId === "8" && (!orderDetails?.courierService || !orderDetails?.trackingNumber)
      ) {
        // Display a warning message (you can use a library or create a custom modal for this)
        alert("Please fill in all of the required details");
        return;
      }

    // Validation passed, proceed with adding the customer
    onUpdateStatus({
      ...orderDetails,
    //   action: "Add",
    });

    setOrderDetails({
        id: 0,
        statusId: "2",
        courierService: "",
        trackingNumber: "",
    });

    onClose();
  };


  const handleClose = () => {
    // Clear inputs and reset state
    setOrderDetails({
        id: 0,
        statusId: "2",
        courierService: "",
        trackingNumber: "",
      });
    // Call the onClose function
    onClose();
  };

  return (
    <Modal
      opened={isVisible}
      onClose={handleClose}
      size="md"
      padding="lg"
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Update Status
        </div>
      }
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleUpdateStatus();
        }}
      >


        <Select
            label="Status"
            placeholder="Select status"
            required
            // defaultValue={'NONE'}
            data={[
                { value: '2', label: 'Processing' },
                { value: '7', label: 'Packing' },
                { value: '8', label: 'Fulfilled' },
            ]}
            onChange={(value, option) =>
                setOrderDetails({ ...orderDetails, statusId: value })
            }
            value={orderDetails?.statusId ? orderDetails?.statusId : '2'}
            allowDeselect={false}
            mb="sm"
        />

        {orderDetails?.statusId === '8' ? 
        <>
        <Select
            label="Courier Service"
            placeholder="Select courier service"
            required
            // defaultValue={'NONE'}
            data={[
                { value: 'GDEX', label: 'GDEX' },
                { value: 'J&T Express', label: 'J&T Express' },
                { value: 'Lalamove', label: 'Lalamove' },
            ]}
            onChange={(value, option) =>
                setOrderDetails({ ...orderDetails, courierService: value })
            }
            value={orderDetails?.courierService}
            mb="sm"
        />

        <TextInput
            label="Tracking Number"
            placeholder=""
            mb="sm"
            maxLength={255}
            value={orderDetails?.trackingNumber}
            onChange={(event) =>
                setOrderDetails({ ...orderDetails, trackingNumber: event.currentTarget.value })
            }
        />
        </>
        : null}

        <Group className={classes.buttonBottom}>
          <Button onClick={() => handleClose()} className={classes.buttonCancel}>
            Back
          </Button>
          <Button type="submit" className={classes.buttonSaveChanges}>
            Submit
          </Button>
        </Group>
      </form>
    </Modal>
  );
};

export default WebOrderUpdateModal;
